import "core-js/modules/es.array.reverse.js";
var _class, _descriptor, _CesiumTerrainCatalogItem;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { computed, makeObservable, observable, override, runInAction } from "mobx";
import CesiumTerrainProvider from "terriajs-cesium/Source/Core/CesiumTerrainProvider";
import IonResource from "terriajs-cesium/Source/Core/IonResource";
import CatalogMemberMixin from "../../../ModelMixins/CatalogMemberMixin";
import MappableMixin from "../../../ModelMixins/MappableMixin";
import UrlMixin from "../../../ModelMixins/UrlMixin";
import CesiumTerrainCatalogItemTraits from "../../../Traits/TraitsClasses/CesiumTerrainCatalogItemTraits";
import CreateModel from "../../Definition/CreateModel";
let CesiumTerrainCatalogItem = (_class = (_CesiumTerrainCatalogItem = class CesiumTerrainCatalogItem extends UrlMixin(MappableMixin(CatalogMemberMixin(CreateModel(CesiumTerrainCatalogItemTraits)))) {
  constructor() {
    super(...arguments);
    /**
     * An observable terrain provider instance set by forceLoadMapItems()
     */
    _initializerDefineProperty(this, "terrainProvider", _descriptor, this);
    makeObservable(this);
  }
  get type() {
    return CesiumTerrainCatalogItem.type;
  }
  get disableZoomTo() {
    return true;
  }
  get isTerrainActive() {
    return this.terria.terrainProvider === this.terrainProvider;
  }
  get shortReport() {
    if (super.shortReport === undefined) {
      const status = this.isTerrainActive ? "In use" : "Not in use";
      return "Terrain status: ".concat(status);
    }
    return super.shortReport;
  }

  /**
   * Returns a Promise to load the terrain provider
   */
  loadTerrainProvider() {
    const resource = this.ionAssetId !== undefined ? IonResource.fromAssetId(this.ionAssetId, {
      accessToken: this.ionAccessToken || this.terria.configParameters.cesiumIonAccessToken,
      server: this.ionServer
    }) : this.url;
    if (resource === undefined) {
      return Promise.resolve(undefined);
    }
    return CesiumTerrainProvider.fromUrl(resource, {
      credit: this.attribution
    });
  }
  async forceLoadMapItems() {
    const terrainProvider = await this.loadTerrainProvider();
    runInAction(() => {
      this.terrainProvider = terrainProvider;
    });
  }
  get mapItems() {
    return this.show && this.terrainProvider ? [this.terrainProvider] : [];
  }
}, _defineProperty(_CesiumTerrainCatalogItem, "type", "cesium-terrain"), _CesiumTerrainCatalogItem), _descriptor = _applyDecoratedDescriptor(_class.prototype, "terrainProvider", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return undefined;
  }
}), _applyDecoratedDescriptor(_class.prototype, "disableZoomTo", [override], Object.getOwnPropertyDescriptor(_class.prototype, "disableZoomTo"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isTerrainActive", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isTerrainActive"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "shortReport", [override], Object.getOwnPropertyDescriptor(_class.prototype, "shortReport"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "mapItems", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "mapItems"), _class.prototype), _class);
export { CesiumTerrainCatalogItem as default };